import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {toggleModal} from "../../store/actions/toggleModalActions";
import {isCustomer, isSuperAdmin} from "../../helpers/helpers";
import {addGateSwitcher, deleteGateSwitcher, editGateSwitcher} from "../../store/actions/gateSwitchersActions";
import searchIcon from "../../assets/icons/plus.svg";
import ExternalModal from "../_common/ExternalModal";
import ManageUsers from "../ManageUsers";
import Sensor from "../Sensor";
import Select from "react-select";
import {customStyles} from "../../helpers/selectStyles";
import ButtonSpinner from "../_common/ButtonSpinner";

const selector = state => {
    const { language, disableButtons, gateSwitchers, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        gateSwitchersAlertRules: gateSwitchers.gateSwitchersAlertRules || [],
        modalState: modalState
    }
};

const defaultForm = {
    setName: '',
    controlSetId: '',
    remoteSwitchId: '',
    // gateSwitchId: '',
    alertRuleId: '',
    humidityAlertRuleId: '',
    humidityFirst: false,
    dataSensorId: '',
    userId: '',
}


const GateSwitcherModal = props => {
    const {edit, details, gateSwitcher} = props;
    const { t, disableButtons, gateSwitchersAlertRules } = useSelector(selector);
    const dispatch = useDispatch();

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [formValues, setFormValues] = useState({...defaultForm})
    const [nameValues, setNameValues] = useState({})
    const [sensorsModal, setSensorsModal] = useState({isOpen: false, type: '', enumType: '', name: ''})
    const [usersModal, setUsersModal] = useState({isOpen: false, name: ''})
    const [error, setError] = useState(false)

    const [selectedGateSwitcherAlertRule, setSelectedGateSwitcherAlertRule] = useState(null)
    const [selectedHumidityAlertRule, setSelectedHumidityAlertRule] = useState(null)

    const temperatureAlertRules = gateSwitchersAlertRules.filter(rule => rule.measurementType === 'TEMPERATURE')
    const humidityAlertRules = gateSwitchersAlertRules.filter(rule => rule.measurementType === 'HUMIDITY')

    useEffect(() => {
        if(gateSwitcher) {
            setFormValues({
                controlSetId: gateSwitcher && gateSwitcher.controlSetId ? gateSwitcher.controlSetId : '',
                setName: gateSwitcher && gateSwitcher.setName ? gateSwitcher.setName : '',
                dataSensorId: gateSwitcher && gateSwitcher.dataSensorId ? gateSwitcher.dataSensorId : '',
                // gateSwitchId: gateSwitcher && gateSwitcher.gateSwitchId ? gateSwitcher.gateSwitchId : '',
                remoteSwitchId: gateSwitcher && gateSwitcher.remoteSwitchId ? gateSwitcher.remoteSwitchId : '',
                alertRuleId: gateSwitcher && gateSwitcher.alertRuleId ? gateSwitcher.alertRuleId : '',
                humidityAlertRuleId: gateSwitcher && gateSwitcher.humidityAlertRuleId ? gateSwitcher.humidityAlertRuleId : '',
                humidityFirst: Boolean(
                    gateSwitcher &&
                    gateSwitcher.humidityFirst &&
                    gateSwitcher.alertRuleId &&
                    gateSwitcher.humidityAlertRuleId
                ),
            })
            setNameValues({
                switcherSensorName: gateSwitcher && gateSwitcher.remoteSwitch && gateSwitcher.remoteSwitch.name ? gateSwitcher.remoteSwitch.name : '',
                temperatureSensorName: gateSwitcher && gateSwitcher.dataSensor && gateSwitcher.dataSensor.name ? gateSwitcher.dataSensor.name : '',
                userName: gateSwitcher && gateSwitcher.userName  ? gateSwitcher.userName : ''
            })

        }
    },[gateSwitcher])

    useEffect(() => {
        if(gateSwitcher && gateSwitchersAlertRules.length) {
            setSelectedGateSwitcherAlertRule(
                gateSwitchersAlertRules.find(rule => rule.ruleID === gateSwitcher.alertRuleId) || null
            )
            setSelectedHumidityAlertRule(
                gateSwitchersAlertRules.find(rule => rule.ruleID === gateSwitcher.humidityAlertRuleId) || null
            )
        }
    }, [gateSwitcher, gateSwitchersAlertRules])

    const selectGateSwitcherAlertRule = (rule) => {
        setSelectedGateSwitcherAlertRule(rule)
        setFormValues({...formValues, alertRuleId: rule.ruleID})
    }

    const selectHumidityAlertRule = (rule) => {
        setSelectedHumidityAlertRule(rule)
        setFormValues({...formValues, humidityAlertRuleId: rule.ruleID})
    }

    const handleDeleteGateSwitcherClick = () => {
        setDeleteConfirmation(!deleteConfirmation)
    };

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const toggleSensorsModal = (type, enumType, name) => {
        setSensorsModal({isOpen: !sensorsModal.isOpen, type: type, enumType: enumType, name: name})
    }

    const toggleUsersModal = (name) => {
        setUsersModal({isOpen: !usersModal.isOpen, name: name})
    }

    const selectSensorId = (sensorType, sensor, sensorName, name) => {
        setFormValues({...formValues, [sensorType]: sensor.toString()})
        setNameValues({...nameValues, [sensorName]: name})
    }

    const selectUserId = (id, name) => {
        setFormValues({...formValues, userId: id.toString() })
        setNameValues({...nameValues, userName: name})
    }

    const handleAddGateSwitcherClick = () => {
        const validatedFormValues = {
            ...formValues,
            humidityFirst: Boolean(
                formValues.humidityFirst &&
                formValues.alertRuleId &&
                formValues.humidityAlertRuleId
            )
        }

        if(!isCustomer()) {
            if(formValues.setName.length && formValues.userId.length) {
                if(!edit) {
                    dispatch(addGateSwitcher(validatedFormValues))
                } else {
                    dispatch(editGateSwitcher(validatedFormValues))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        } else {
            if(formValues.setName.length) {
                if(!edit) {
                    dispatch(addGateSwitcher(validatedFormValues))
                } else {
                    dispatch(editGateSwitcher(validatedFormValues))
                }
                closeModal()
            } else {
                setError(true)
                setTimeout(() => setError(false), 5000)
            }
        }
    }

    const confirmDeleteGateSwitcher = id => {
        dispatch(deleteGateSwitcher(id))
        closeModal()
    }

    return (
        <div
            className={details ? 'userModalDetails' : 'userModalBlur'}
            onClick={e => {
                if(e.target.className === 'userModalBlur') {
                    closeModal()
                }
            }}
        >
            <div style={{height: '90%'}} className={details ? 'userModal inDetails' : 'userModal'}>
                <div className="userModalHeader">
                    <div className="userModalTitleContainer">
                        <div className='userModalTitle'>
                            {!edit ? t.gettext('Add Gate Switcher') : t.gettext('Edit Gate Switcher')}
                        </div>
                    </div>
                    <div className='userModalCloseButtonHolder'>
                        <span
                            className='material-icons userModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div style={!error ? {"visibility": "hidden"} : null}
                     className='weatherStationError'>{t.gettext('Some required fields are missing')}.
                </div>
                <div className='userModalContent weatherStationContent'>
                    <form className="userForm" autoComplete='off'>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                style={error && !formValues.setName ? {'borderBottom': '1px solid #D91212'} : null}
                                className='userFormInput'
                                defaultValue={gateSwitcher ? gateSwitcher.setName : ''}
                                onInput={e => {
                                    setFormValues({...formValues, setName: e.target.value});
                                }}
                                type='text'
                            />
                        </div>
                        {details && (
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('User Name')}
                                </label>
                                <input

                                    className='userFormInput'
                                    defaultValue={gateSwitcher ? gateSwitcher.userName : ''}
                                    disabled
                                    type='text'
                                />
                            </div>
                        )}
                        {!isCustomer() &&
                            <div className='userFormItem sensorPickerInput'>
                                <label className='userFormLabel'>
                                    {t.gettext('User')}
                                </label>
                                <input
                                    readOnly
                                    style={error && !formValues.userId ? {'borderBottom': '1px solid #D91212'} : null}
                                    className='userFormInput'
                                    onInput={e => {
                                        setFormValues({...formValues, userId: e.target.value});
                                    }}
                                    type='text'
                                    value={nameValues.userName}
                                    // defaultValue={station ? station.userId : formValues.userId}
                                    // value={formValues.userId}
                                />
                                <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                     onClick={() => toggleUsersModal()}/>
                            </div>
                        }
                        <div className='userFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Temperature Alert Rule')}
                            </label>
                            <div style={{padding: '10px 0'}}>
                                <Select
                                    options={temperatureAlertRules}
                                    // isDisabled={sensorsDetailsPending}
                                    // isMulti
                                    maxMenuHeight={200}
                                    placeholder={t.gettext('Select...')}
                                    styles={customStyles}
                                    onChange={selectGateSwitcherAlertRule}
                                    value={selectedGateSwitcherAlertRule}
                                    noOptionsMessage={() => t.gettext('No options')}
                                />
                            </div>
                        </div>
                        {selectedGateSwitcherAlertRule && (
                            <div className="stationModalFormRow">
                                <div className='userFormItem stationFormItem'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Temp Close')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        disabled={true}
                                        value={selectedGateSwitcherAlertRule?.tempClose}
                                        type='number'
                                    />
                                </div>
                                <div className='userFormItem stationFormItem'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Temp Open')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        disabled={true}
                                        type='number'
                                        value={selectedGateSwitcherAlertRule?.tempOpen}
                                    />
                                </div>
                            </div>
                        )}
                        <div className='userFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Humidity Alert Rule')}
                            </label>
                            <div style={{padding: '10px 0'}}>
                                <Select
                                    options={humidityAlertRules}
                                    maxMenuHeight={200}
                                    placeholder={t.gettext('Select...')}
                                    styles={customStyles}
                                    onChange={selectHumidityAlertRule}
                                    value={selectedHumidityAlertRule}
                                    noOptionsMessage={() => t.gettext('No options')}
                                />
                            </div>
                        </div>
                        {selectedHumidityAlertRule && (
                            <div className="stationModalFormRow">
                                <div className='userFormItem stationFormItem'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Humidity Close')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        disabled={true}
                                        value={selectedHumidityAlertRule?.humidityClose}
                                        type='number'
                                    />
                                </div>
                                <div className='userFormItem stationFormItem'>
                                    <label className='userFormLabel'>
                                        {t.gettext('Humidity Open')}
                                    </label>
                                    <input
                                        className='userFormInput'
                                        disabled={true}
                                        type='number'
                                        value={selectedHumidityAlertRule?.humidityOpen}
                                    />
                                </div>
                            </div>
                        )}
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                <input
                                    type='checkbox'
                                    checked={Boolean(
                                        formValues.humidityFirst &&
                                        formValues.alertRuleId &&
                                        formValues.humidityAlertRuleId
                                    )}
                                    disabled={!formValues.alertRuleId || !formValues.humidityAlertRuleId}
                                    onChange={e => setFormValues({...formValues, humidityFirst: e.target.checked})}
                                />
                                <span style={{marginLeft: '8px'}}>{t.gettext('Humidity rule has precedence')}</span>
                            </label>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('Switcher Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, remoteSwitchId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.switcherSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 onClick={() => toggleSensorsModal('remoteSwitchId', 'SWITCHER_SENSOR', 'switcherSensorName')}/>
                        </div>
                        <div className='userFormItem sensorPickerInput'>
                            <label className='userFormLabel'>
                                {t.gettext('Temperature Sensor')}
                            </label>
                            <input
                                readOnly
                                className='userFormInput '
                                onInput={e => {
                                    setFormValues({...formValues, dataSensorId: e.target.value});
                                }}
                                type='text'
                                // defaultValue={station ? station.rainSensorId : formValues.rainSensorId}
                                value={nameValues.temperatureSensorName}
                            />
                            <img className={'inputIcon icon--right'} src={searchIcon} alt='icon'
                                 onClick={() => toggleSensorsModal('dataSensorId', 'TEMPERATURE_SENSOR', 'temperatureSensorName')}/>
                        </div>
                        <div className='userButtonsHolder'>
                            {!edit &&
                                <button
                                    className='userAddButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddGateSwitcherClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add Gate Switcher')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            }

                            {edit &&

                                <>
                                    <button
                                        className='userAddButton userDeleteButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleDeleteGateSwitcherClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Delete')}
                                    </button>
                                    <button
                                        className='userAddButton userEditButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleAddGateSwitcherClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Save')}
                                        {disableButtons && <ButtonSpinner black/>}
                                    </button>
                                </>

                            }
                        </div>
                        {deleteConfirmation &&
                            <div className='userDeleteConfirmation' style={{justifyContent: 'center'}}>
                                {gateSwitcher.setName + ' ' + t.gettext('will be deleted')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmDeleteGateSwitcher(gateSwitcher.controlSetId);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteGateSwitcherClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        {sensorsModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleSensorsModal(sensorsModal.type)}
                                title={'Sensors'}
                            >
                                <Sensor
                                    gateSwitcherSensors
                                    sensorPicker
                                    sensorPickerEnum={sensorsModal.enumType}
                                    selectSensorPicker={selectSensorId}
                                    sensorPickerType={sensorsModal.type}
                                    sensorPickerName={sensorsModal.name}
                                    toggleSensorPicker={toggleSensorsModal}
                                    userId={formValues.userId}
                                />
                            </ExternalModal>
                        }
                        {usersModal.isOpen &&
                            <ExternalModal
                                closeMethod={() => toggleUsersModal()}
                                title={'Users'}
                            >
                                <ManageUsers
                                    superAdmin={isSuperAdmin()}
                                    userPicker
                                    selectUserPicker={selectUserId}
                                    toggleUserPicker={toggleUsersModal}
                                />
                            </ExternalModal>
                        }
                    </form>
                </div>
            </div>
        </div>
    )

}

export default GateSwitcherModal
